(function(VetsConnect, $, window, document) {
  'use strict';
  //## Header Scripts
  var homeScripts = (function() {
    var GLOBS = {
      formTabs: document.getElementById('form_tabs'),
      $heroFormCbox: $('.hero_cbox'),
      $heroSelectBox: $('.js_select'),
      $eventCalendar: $('#datepicker'),
      $body: $('body'),
      $popupTriggerDonation: $('.popup_trigger_donation'),
      $popupDonation: $('.donations_popup'),
      $closePopup: $('.close_popup'),
      $popup: $('.popup'),
      $doc: $(document),
      visibleClass: 'is--visible',
      activeClass: 'is--active'
    };
    $.fn.toggleAttr = function(attr, attr1, attr2) {
      return this.each(function() {
        var self = $(this);
        if (self.attr(attr) == attr1)
          self.attr(attr, attr2);
        else
          self.attr(attr, attr1);
      });
    };
    $('.equal_height').matchHeight();
    if ($('.inf-scroll').length > 0) {
      setTimeout(function () {
        $('.inf-scroll').each(function() {
          try{
            $(this).initInfScroll();
          }catch(e){console.log(e)}
        });
      }, 300)
    }

    var userAgent, ieReg, ie;
    userAgent = window.navigator.userAgent;
    ieReg = /msie|Trident.*rv[ :]*11\./gi;
    ie = ieReg.test(userAgent);


    function ieObjectFit() {
      $(".ie_object_fit").each(function () {
        var $container = $(this),
            img = $container.find("img"),
            imgUrl = img.prop("src");
        if (imgUrl) {
          img.css('opacity','0');
          $container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("custom-object-fit");
        }
      });
    }

    if(ie) {
      $(".event_cat").addClass('ie_object_fit');
      $(".about_box__img").addClass('ie_object_fit');
      $(".news_img_holder").addClass('ie_object_fit');
  
      ieObjectFit();
    }

    function closePopup() {
      GLOBS.$popup.fadeOut(300);
    };
    //Binds all handle functions to a new function which is called @init 
    var bindEvents = function() {
      //toggle placeholder
      GLOBS.$heroFormCbox.click(function(event) {
        var $this = $(this),
          $thisParentInput = $this.parent().parent().find('input[type="search"]'),
          $thisParentInputPlaceholder = $thisParentInput.data('old-placeholder');
        console.log($thisParentInputPlaceholder)
        $thisParentInput.toggleAttr('placeholder', 'Search by state', $thisParentInputPlaceholder);
        $this.parent().parent().toggleClass('has_state');
      });
      //open donation popup
      GLOBS.$popupTriggerDonation.click(function(event) {
        event.preventDefault();
        GLOBS.$popupDonation.fadeIn(300);
      });
      //Close popup
      GLOBS.$closePopup.click(function(event) {
        event.preventDefault();
        closePopup();
      });
      GLOBS.$doc.keyup(function(e) {
        if (e.keyCode == 27) {
          closePopup();
        }
      });
      GLOBS.$doc.mouseup(function(e) {
        if ($('.popup').length > 0) {
          var container = $('.popup').find('.popup__content');
          if (!container.is(e.target) && container.has(e.target).length === 0) {
            closePopup();
          }
        }
      });
      $('#nav_toggle').click(function(event) {
        event.preventDefault();
        $('#main_nav_wrapper').slideToggle();
        $('body').toggleClass('nav_active');
      });
    };
    var init = function() {
      bindEvents();
    };
    var initPlugins = function() {
      //If tabs exist init
      if (GLOBS.formTabs) {
        tabby.init();
      }
      //Init selectbox and nicescroll
      GLOBS.$heroSelectBox.select2({
        minimumResultsForSearch: Infinity
      }).on("select2:open", function() {
        $('.select2-results__options').niceScroll();
      });

      $('.select_2_custom').select2({
        minimumResultsForSearch: Infinity,
        dropdownCssClass: 'select_form'
      }).on("select2:open", function() {
        $('.select2-results__options').niceScroll();
      });
      // Init datepicker
      GLOBS.$eventCalendar.each(function () {
        var selectedDate = $(this).attr('data-selected-date');

        $(this).datepicker({
            showOtherMonths: true,
            selectOtherMonths: true,
            defaultDate: selectedDate,
            onSelect: function(dateText, inst) { 
              var url = $(inst.input[0]).attr('data-base-url');
  
              if (! url) {
                url = window.location.href;
              }
  
              var d = addLeadingZero(inst.selectedMonth + 1) + "/" + addLeadingZero(inst.selectedDay) + "/" + inst.selectedYear;

              var query = (url.indexOf('?') > -1 ? '&' : '?') + 'date_from=' + d;
  
              url = url + query;
  
              if (window.location.href != url) {
                window.location.href = url;
              }
            },

            beforeShowDay: function (date) {
              var date = addLeadingZero(date.getMonth() + 1) + '/' + addLeadingZero(date.getDate()) + '/' +  date.getFullYear();

              return [selectedDates.indexOf(date) > -1, selectedDates.indexOf(date) > -1 ? 'has_events' : '']
            },
        });

        function addLeadingZero(nr) {
          return nr < 10 ? '0' + nr : nr;
        }
      });
    };
    return {
      init: init,
      initPlugins: initPlugins
    };
  }());
  //## END General Scripts
  //## EXTENSION MAIN
  var VCMain = (function() {
    var init = function() {
      homeScripts.init();
      homeScripts.initPlugins();
      $('select').removeClass('.hidden_loader');
    };
    return {
      init: init
    };
  }());
  //## END EXTENSION MAIN
  //Doc Ready
  document.addEventListener('DOMContentLoaded', function() {
    VCMain.init();
  }, false);
})(window.VetsConnect = window.VetsConnect || {}, window.jQuery, window, document);
